export default {
  ApplicationInfo: '신청 정보',
  Game: '게임',
  Account: '계정',
  Server: '서버',
  CharacterName: '캐릭터명',
  PlatformOrderNumber: '플랫폼 주문 번호',
  Amount: '금액',
  InvoiceMethod: '인보이스 발행 방식',
  InvoiceByTotalOrderAmount: '주문 총액에 따라 인보이스 발행',
  InvoiceByOrderAmountSeparately: '주문 금액에 따라 별도로 인보이스 발행',
  PhoneNumber: '연락처',
  Name: '성명',
  Address: '주소',
  InvoiceTitle: '인보이스 수신인',
  PersonalTitleOnlyNoCompany: '개인만 지원하며, 회사는 지원하지 않습니다.',
  ReceivingEmail: '수신 이메일',
  Remarks: '비고',
  InputContent: '내용 입력',
  ApplicationSubmittedSuccessfully: '신청서 제출 성공',
  InvoiceApplicationSubmittedSuccessfully:
    '귀하의 인보이스 신청서가 제출되었습니다.\r\n담당자가 영업일 7일 이내에 처리할 예정이오니, 이메일을 꼭 확인해 주시기 바랍니다.',
  Confirm: '확인',
  Submit: '제출',
  ApplicationSubmissionFailed: '신청서 제출 실패',
  InvoiceApplicationFailed:
    '인보이스 신청서 제출에 실패했습니다. 새로고침 후 다시 시도하거나 고객센터에 문의하세요.',
  InvoiceApplicationSubmitted:
    '귀하의 인보이스 신청이 제출되었습니다. 중복 제출하지 마십시오.',
  PleaseEnterName: '이름을 입력하세요',
  PleaseEnterAddress: '주소를 입력하세요',
  PleaseEnterInvoiceTitle: '인보이스 수신인을 입력하세요',
  PleaseEnterEmail: '수신할 이메일 주소를 입력하세요',
  PleaseEnterRemarks: '비고 정보를 입력하세요',
  NumberParsingError: '번호 분석 오류',
  PleaseEnterValidEmailFormat: '유효한 이메일 주소 형식을 입력하세요',
  IncompleteInformation: '정보가 불완전합니다. 다시 한번 확인해 주세요.',
  ExpandAll: '모두 펼치기'
};
